module.exports = __webpack_public_path__ + "static/sport/img-swiper3.47e123f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/euro/img-swiper3.png
// module id = ML5t
// module chunks = 0